export default "__VITE_ASSET__128245a3__"